import axios from "axios";
export default {
  namespaced: true,
  state: {
    // state of app. can store anything from strings to objects
    token: null,
    user: null,
    users: [],
    deleted_users: [],
  },
  // read info from state
  getters: {
    authenticated(state) {
      return state.token && state.user;
    },
    user(state) {
      return state.user;
    },
    token(state) {
      return state.token;
    },
    default_server_url() {
      return process.env.VUE_APP_SERVER_URL;
    },
    users(state) {
      return state.users;
    },
    deleted_users(state) {
      return state.deleted_users;
    },
  },
  mutations: {
    // update the state
    SET_TOKEN(state, token) {
      state.token = token;
    },
    SET_USER(state, data) {
      state.user = data;
    },
    SET_USERS(state, data) {
      state.users = data;
    },
    ADD_USER(state, user) {
      state.users.unshift(user);
    },
    DELETE_USER(state, user) {
      let filtered = state.users.filter((c) => {
        return c.id != user.id;
      });
      state.users = filtered;
    },

    EDIT_USER(state, user) {
      var index = state.users.findIndex((a) => a.id == user.id);
      state.users.splice(index, 1, user);
    },
    SET_DELETED_USERS(state, data) {
      state.deleted_users = data;
    },
    RESTORE_USER(state, user) {
      state.deleted_users = state.deleted_users.filter((c) => {
        return c.id != user.id;
      });
      state.users.unshift(user);
    },
  },
  actions: {
    async delete_user({ commit, dispatch }, request) {
      await axios.delete("/user/" + request.id);
      commit("DELETE_USER", request);
      await dispatch("get_deleted_users");
    },

    async get_deleted_users({ commit }) {
      let response = await axios.get("/deleted_users");
      commit("SET_DELETED_USERS", response.data);
    },

    async restore_user({ commit }, request) {
      let response = await axios.post("/user/" + request.id + "/restore");
      commit("RESTORE_USER", response.data);
    },

    async edit_user({ commit }, request) {
      let response = await axios.put("/user", request);
      commit("EDIT_USER", response.data);
    },

    async add_user({ commit }, request) {
      let response = await axios.post("/user", request);
      commit("ADD_USER", response.data);
    },
    async get_users({ commit }) {
      let response = await axios.get("/users");
      commit("SET_USERS", response.data);
    },
    // make request to api but commit to mutations
    async signin({ dispatch }, credentials) {
      let response = await axios.post("auth/signin", credentials, {
        timeout: 10000,
      });
      return dispatch("attempt", response.data);
    },
    // attempt to access me api to check if token is valid
    // and give us back the users info
    async attempt({ commit, state }, token) {
      // if there is a token, commit
      if (token) {
        commit("SET_TOKEN", token);
      }
      // if there is no token in the sate, stop the execution
      if (!state.token) {
        return;
      }
      // check token if it is valid in me api
      try {
        // pass header for authorization
        let response = await axios.get("auth/attempt", { timeout: 10000 });
        // if it is true, set_user to response
        commit("SET_USER", response.data);
      } catch (e) {
        commit("SET_TOKEN", null);
        commit("SET_USER", null);
        throw e;
      }
    },
    async signout({ commit }) {
      return axios.post("auth/signout").then(() => {
        commit("SET_TOKEN", null);
        commit("SET_USER", null);
      });
    },
    async on_page_reload({ dispatch, rootState }) {
      // if page gets refreshed
      if (!rootState.branch.branches) {
        await dispatch("branch/get_branches", "", { root: true });
      }

      return true;
    },
  },
};
